// Media items are stored at "<umbracoSiteRoot>/media/...". On the Umbraco instances the app is
// served from "<umbracoSiteRoot>/output/event/<env>/", so the site root is whatever precedes
// "/output/". On the CDN the site is mirrored under a prefix (e.g. "/event_preprod/", "/event/")
// and the app is served from that prefix, so the app's own directory is the site root.
function getUmbracoSiteRoot()
{
   var path = window.location.pathname;
   // NOTE: Only strip the last segment when it is a file (e.g. "/event_preprod/index.html").
   var appDirectory = /\.[^/]*$/.test(path) ? path.substring(0, path.lastIndexOf('/') + 1) : path;

   var outputIndex = appDirectory.indexOf('/output/');
   var siteRoot = outputIndex !== -1 ? appDirectory.substring(0, outputIndex) : appDirectory;

   return siteRoot.replace(/\/+$/, ''); // NOTE: No trailing slash, it is added when joining.
}

var umbracoDevelopmentHost = 'https://intellian-umbraco-13-c6d8f8fzf0hcb9fh.northeurope-01.azurewebsites.net';

var config = {
   manifestPath: 'assets/json/en/manifest.json',
   tempMediaPath: umbracoDevelopmentHost + '/output/event/development/',
   umbracoMediaPath: getUmbracoSiteRoot(),
}
 
if (window.location.hostname === "localhost" )
{
   config.tempMediaPath = '';
   config.umbracoMediaPath = umbracoDevelopmentHost;
}
 
// TODO: Add list of smaller assets to preload here. Like SVG icons and the logo. For preloading

export default config;